import React, {useContext, useEffect} from "react";
import AuthCheck from "../components/AuthCheck";
import {Button, Card, Col, Container, InputGroup, Nav, Navbar, Row} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import {accountContext} from "../App";


import Form from "react-bootstrap/Form";
import {Formik} from "formik";
import axios from "axios";
export default function ModuleCreate() {
    let navigate = useNavigate();
    useContext(accountContext);
    useEffect(()=>{

    }, []);



    return(
        <>
            <AuthCheck/>
            <Container>
                <Formik
                    initialValues={{ moduleName: '',students: ''}}
                    validate={values => {
                        const errors = {};
                        if (!values.moduleName) {
                            errors.moduleName = 'Required';
                        }
                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                            const formData = new FormData();
                            for (const fileName in values) {
                                if( values[fileName] instanceof FileList){
                                    values[fileName]= values[fileName][0];
                                }
                                formData.append(fileName, values[fileName]);
                            }
                            console.log(Array.from(formData.entries()));
                            axios.post(  "/api/module", formData).then(res => {
                                setSubmitting(false);
                                navigate('/')
                                console.log(res);

                            }).catch(err => {

                            });
                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          setFieldValue
                          /* and other goodies */
                      }) => (
                        <form onSubmit={handleSubmit}>
            <Row  style={{  marginTop: "20px"}}>
                <Navbar bg="light" variant="light">


                    <Nav className="me-auto">
                        <Link to="/">
                            <Button variant="secondary" >
                                Back
                            </Button>
                        </Link>
                    </Nav>
                    <Nav>
                        <Button type="submit" disabled={isSubmitting} variant="primary" >
                            Save
                        </Button>
                    </Nav>
                </Navbar>
            </Row>
                <Row style={{  marginTop: "10px"}}>
                    <Col xs={{span: 5}} >
                        <Card >
                            <Card.Header>
                                Information*
                            </Card.Header>
                            <Card.Body>
                                <span style={{color: "red"}}>{errors.moduleName && touched.moduleName && errors.moduleName}</span>
                                <InputGroup className="mb-3">
                                    <span className="input-group-text">Module ID:</span>
                                    <Form.Control
                                        aria-label="Module ID"
                                        placeholder="KORT2"
                                        name="moduleName"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.moduleName}
                                    />
                                </InputGroup>
                            </Card.Body>
                        </Card>

                    </Col>
                    <Col xs={{span: 7}}>
                        <Card>
                            <Card.Header>
                                Add Students
                            </Card.Header>
                            <Card.Body>
                                <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Label>Upload CSV file bellow to add students</Form.Label>
                                    <Form.Control name="students" type="file" onChange={(event) => {
                                        setFieldValue("students", event.currentTarget.files[0]);
                                    }}/>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
                        </form>
                    )}
                </Formik>
            </Container>



        </>
    )
}

